import { render } from "./StaffDatatableTDTechnicName.vue?vue&type=template&id=0b222d88&scoped=true"
import script from "./StaffDatatableTDTechnicName.vue?vue&type=script&lang=js"
export * from "./StaffDatatableTDTechnicName.vue?vue&type=script&lang=js"

import "./StaffDatatableTDTechnicName.vue?vue&type=style&index=0&id=0b222d88&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b222d88"]])

export default __exports__